<script lang="ts">
	import '../app.css';
	import favicon from '$lib/assets/favicon.svg';
	import { onMount } from 'svelte';
	import { initializeCapacitor, isNativeApp, getAppInfo } from '$lib/capacitor';
	import { QueryClientProvider } from '@tanstack/svelte-query';
	import { getQueryClient } from '$lib/query/client';
	import { authService } from '$lib/auth/service';

	let { children } = $props();

	// Initialize TanStack Query client
	const queryClient = getQueryClient();

	// Initialize Capacitor and Auth when the app loads
	onMount(async () => {
		console.log('[Root Layout] Initializing app...');

		await initializeCapacitor();

		// Log app info for debugging
		const appInfo = await getAppInfo();
		console.log('[Root Layout] App Info:', appInfo);
		console.log('[Root Layout] Is Native App:', isNativeApp());

		// Initialize auth service
		console.log('[Root Layout] Initializing auth service...');
		try {
			await authService.initialize();
			console.log('[Root Layout] Auth service initialized successfully');
		} catch (error) {
			console.error('[Root Layout] Failed to initialize auth service:', error);
		}
	});
</script>

<svelte:head>
	<link rel="icon" href={favicon} />
</svelte:head>

<QueryClientProvider client={queryClient}>
	{@render children?.()}
</QueryClientProvider>
